import { createReducer } from '../../utilities';

import { scope } from '../../../actions/app/tools/dlpicture';
import { REQUEST_FETCH_PLAYERS, SUCCESS_FETCH_PLAYERS, FAIL_FETCH_PLAYERS } from '../../../actions/entities/player';

const initialState = {
    ids: null,
    info: {
        isFetching: false,
        lastAction: null,
        lastPayload: {},
        needRefresh: true,
        updatedAt: null,
        success: false,
        error: false
    }
};

function request(state, action) {
    return {
        ...state,
        info: {
            isFetching: true,
            lastAction: action.type,
            lastPayload: action.payload,
            needRefresh: false,
            updatedAt: null,
            success: false,
            error: false
        }
    };
}

function success(state, action) {
    const { ids, payload, receivedAt, success } = action;
    return {
        ...state,
        ids: ids || state.ids,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            updatedAt: receivedAt,
            success,
            error: false
        }
    };
}

function fail(state, action) {
    const { error, payload } = action;
    return {
        ...state,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            success: false,
            error
        }
    };
}

export default createReducer(initialState, {
    [REQUEST_FETCH_PLAYERS]: request,
    [SUCCESS_FETCH_PLAYERS]: success,
    [FAIL_FETCH_PLAYERS]: fail,
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/tools/dlpicture.js